export default "__VITE_ASSET__ZT4QF3O___"